const language = window.Realize.i18n
const decimalSeparator = language.currentLocale === 'en' ? '.' : ','
const thousandSeparator = language.currentLocale === 'en' ? ',' : '.'

/**
 * @typedef {Object} Config
 * @property {Number} digits - Quantidade de casas decimais
 * @property {String} prefix - Prefixo da máscara
 */

/**
 * @description Aplica máscara de separação de milhar com ponto(.)
 * @param {Object} event Objeto com propriedades e métodos do DOM
 * @returns {Object} Objeto event com o target.value formatado com a máscara
 */
export const integer = (event) => {
	let value = event.target.value;

	value = value
		.replace(/\D/g, '')
		.replace(/(?=(\d{3})+(?!\d))\B/g, thousandSeparator);

	event.target.value = value;
	return event;
}

/**
 * @description Aplica máscara com prefixo, separação de milhar com ponto(.) e separação de decimais com virgula(,)
 * @param {Object} event Objeto com propriedades e métodos do DOM
 * @param {Config} config Objeto com configurações da máscara
 * @returns {Object} Objeto event com o target.value formatado com a máscara
 */
export const decimal = (event, config) => {
	const { digits, prefix } = config
	let value = event.target.value;
	const regex = new RegExp(`(\\d)(\\d{${digits}})$`)

	value = value
		.replace(/\D/g, '')
		.replace(regex, `$1${decimalSeparator}$2`)
		.replace(/(?=(\d{3})+(\D))\B/g, thousandSeparator);

	if(prefix) {
		value = value.replace(/(.)/, `${prefix}$1`)
	}

	event.target.value = value;
	return event;
}

/**
 * @description Aplica máscara monetária separando milhar com ponto(.) e decimais com virgula(,)
 * @param {Object} event Objeto com propriedades e métodos do DOM
 * @param {Config} config Objeto com configuraçoes da máscara
 * @returns {Object} Objeto event com o target.value formatado com a máscara
 */
export const currency = (event, config) => {
	const { prefix } = config
	let value = event.target.value;

	value = value
		.replace(/\D/g, '')
		.replace(/(\d)(\d{2})$/, `$1${decimalSeparator}$2`)
		.replace(/(?=(\d{3})+(\D))\B/g, thousandSeparator)

	if(prefix) {
		value = value.replace(/(.)/, `${prefix}$1`)
	}

	event.target.value = value;
	return event;
}

/**
 * @description Aplica máscara de data no formato DD/MM/AAAA
 * @param {Object} event Objeto com propriedades e métodos do DOM
 * @returns {Object} Objeto event com o target.value formatado com a máscara
 */
export const date = (event) => {
	let value = event.target.value;
	event.target.maxLength = 10

	if(value.length < 8){
		value = value
			.replace(/(\d{2})(\d)/, '$1/$2')
			.replace(/(\d{2})(\d)/, '$1/$2')
	}
	value.replace(/(\d{2})(\d{4})/, '$2')

	event.target.value = value;
	return event;
}
